export default "__VITE_ASSET__2QV1TRq7__"